import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Notre ADN', path: '/notre-adn' },
    { name: 'Expertises & Réalisations', path: '/expertises-realisations' },
    { name: 'Références', path: '/references' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://cdn.durable.co/logos/17aBKcdoNPhqLxmYocv5nmo1wQqyuLYaKAVADtuA2a0FCRAnWvoQgTGFqwFk2SDz.png"
              alt="ITEC Groupe"
              className="h-14 object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-medium transition-colors duration-300 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-brand-teal'
                    : isScrolled
                    ? 'text-brand-navy hover:text-brand-teal'
                    : 'text-white hover:text-brand-teal'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Right Side - LinkedIn & Contact Button */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href="https://linkedin.com/company/itec1"
              target="_blank"
              rel="noopener noreferrer"
              className={`w-10 h-10 flex items-center justify-center rounded-full transition-colors duration-300 ${
                isScrolled
                  ? 'bg-gray-100 text-brand-navy hover:bg-brand-teal/10 hover:text-brand-teal'
                  : 'bg-white/20 text-white hover:bg-white/30'
              }`}
            >
              <i className="ri-linkedin-fill text-xl"></i>
            </a>
            <Link
              to="/contact"
              className={`px-6 py-2.5 rounded-lg font-semibold text-base transition-all duration-300 whitespace-nowrap ${
                isScrolled
                  ? 'bg-brand-teal text-white hover:bg-brand-teal-dark'
                  : 'bg-white text-brand-teal hover:bg-gray-100'
              }`}
            >
              Contact
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors duration-300 ${
              isScrolled
                ? 'text-brand-navy hover:bg-gray-100'
                : 'text-white hover:bg-white/20'
            }`}
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-6 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-2 text-sm font-medium transition-colors duration-300 ${
                  location.pathname === link.path
                    ? 'text-brand-teal'
                    : 'text-brand-navy hover:text-brand-teal'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-3 border-t border-gray-200 flex items-center gap-3">
              <a
                href="https://linkedin.com/company/itec1"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 text-brand-navy hover:bg-brand-teal/10 hover:text-brand-teal transition-colors duration-300"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <Link
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex-1 text-center px-6 py-2.5 rounded-lg font-semibold text-sm bg-brand-teal text-white hover:bg-brand-teal-dark transition-colors duration-300 whitespace-nowrap"
              >
                Contact
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}